import { render, staticRenderFns } from "./pa-so-shorted-sku.vue?vue&type=template&id=69e57b2c&"
import script from "./pa-so-shorted-sku.vue?vue&type=script&lang=ts&"
export * from "./pa-so-shorted-sku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports